import Api from "configs";

export const loginAdmin = async (user: any) => {
    const response = await Api.post('auth/login', user);
    return response.data;
}